var _rect, _rect2, _text, _text2, _path, _text3, _rect3, _rect4, _text4, _text5, _path2, _text6, _text7, _rect5, _text8, _text9, _path3, _text10, _rect6, _text11, _text12, _path4, _text13, _rect7, _text14, _text15, _path5, _path6, _text16, _text17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalNlpPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 93,
    width: 154,
    height: 43,
    rx: 1,
    fill: "#E9F8E5",
    stroke: "#4D4D4D",
    strokeWidth: 1.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 110,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1F1F1F"
  }, "Input Text")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 125,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 14,
    fill: "#1F1F1F"
  }, "MIMIC-III Fragments")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339 136V170",
    stroke: "#4D4D4D",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 163,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 14,
    fill: "#1F1F1F"
  }, "Tokenized Sequence")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 171,
    width: 307,
    height: 193,
    rx: 7,
    stroke: "#4D4D4D",
    strokeWidth: 1.2,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 186,
    width: 177,
    height: 55,
    rx: 5,
    fill: "#E6E3F7",
    stroke: "#4D4D4D",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 309,
    y: 210,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1F1F1F"
  }, "Bio_ClinicalBERT")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 309,
    y: 226,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 14,
    fill: "#1F1F1F"
  }, "(Pre-trained Transformer)")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309 241V293",
    stroke: "#4D4D4D",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 280,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "Pooled [CLS] Vector")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 294,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "R768")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 293,
    width: 177,
    height: 52,
    rx: 5,
    fill: "#F8ECDF",
    stroke: "#4D4D4D",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 315,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1F1F1F"
  }, "Classification Head")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 331,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 14,
    fill: "#1F1F1F"
  }, "(Dropout + Linear Layer)")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398 319H474",
    stroke: "#4D4D4D",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 431,
    y: 308,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "Logits")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 294,
    width: 153,
    height: 38,
    rx: 4,
    fill: "#F6E7D9",
    stroke: "#4D4D4D",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 564,
    y: 311,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#1F1F1F"
  }, "Cross-Entropy Loss")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 564,
    y: 325,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "(AdamW Optimizer)")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309 345V395",
    stroke: "#4D4D4D",
    strokeWidth: 1.2,
    markerEnd: "url(#arrow)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 331,
    y: 383,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "Softmax Logits")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 397,
    width: 132,
    height: 44,
    rx: 1,
    fill: "#F5E5ED",
    stroke: "#4D4D4D",
    strokeWidth: 1
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 337,
    y: 414,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#1F1F1F"
  }, "Prediction")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 337,
    y: 430,
    textAnchor: "middle",
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "(Codable: 1 or 0)")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M476 315H498",
    stroke: "#4D4D4D",
    strokeWidth: 1.1,
    strokeDasharray: "4 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M584 294V266H458",
    stroke: "#4D4D4D",
    strokeWidth: 1.1,
    strokeDasharray: "4 4",
    markerEnd: "url(#arrow)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 608,
    y: 203,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 13,
    fill: "#1F1F1F"
  }, "Backpropagate Gradients")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 280,
    fontFamily: "Times New Roman, Georgia, serif",
    fontSize: 16,
    fill: "#1F1F1F"
  }, "Fine-Tuned Model")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 8,
    markerHeight: 8,
    refX: 6,
    refY: 4,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 z",
    fill: "#4D4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalNlpPaper);
export default __webpack_public_path__ + "static/media/clinical-nlp-paper.916135b3ff08e7b5f5e3105df4e2e46d.svg";
export { ForwardRef as ReactComponent };